import i18n from "@/i18n";

export const SUBSCRIPTION_DURATIONS = [
  {
    key: "week",
    translation: i18n.tc("subscription.duration.week", 1),
    translation_key: "subscription.duration.week"
  },
  {
    key: "month",
    translation: i18n.tc("subscription.duration.month", 1),
    translation_key: "subscription.duration.month"
  },
  {
    key: "quarter",
    translation: i18n.tc("subscription.duration.quarter", 1),
    translation_key: "subscription.duration.quarter"
  },
  {
    key: "half_year",
    translation: i18n.tc("subscription.duration.half_year", 1),
    translation_key: "subscription.duration.half_year"
  },
  {
    key: "year",
    translation: i18n.tc("subscription.duration.year", 1),
    translation_key: "subscription.duration.year"
  }
];
